"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomInt = void 0;
function getRandomInt(min, max, maxInclusive = false) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    // eslint-disable-next-line security-node/detect-insecure-randomness
    return Math.floor(Math.random() * (maxFloored - minCeiled + (maxInclusive ? 1 : 0)) + minCeiled);
}
exports.getRandomInt = getRandomInt;
//# sourceMappingURL=index.js.map